(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/javascripts/game-package-mappers.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/javascripts/game-package-mappers.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _svs$numbergames = svs.numbergames,
  _svs$numbergames$draw = _svs$numbergames.draws,
  drawsApi = _svs$numbergames$draw.drawsApi,
  jackpotApi = _svs$numbergames$draw.jackpotApi,
  gameWager = _svs$numbergames.gameWager,
  productMapping = _svs$numbergames.productMapping,
  rules = _svs$numbergames.rules;
function generateGames(_ref) {
  let packageSizes = _ref.packageSizes,
    activeIndex = _ref.activeIndex;
  const _ref2 = packageSizes[activeIndex] || {},
    _ref2$games = _ref2.games,
    games = _ref2$games === void 0 ? [] : _ref2$games;
  return games.map((game, index) => {
    var _wager$joker;
    const wager = gameWager.generateWager(game);
    const productItsId = wager.products[0];
    return _objectSpread(_objectSpread({}, wager), {}, {
      hasJoker: Boolean((_wager$joker = wager.joker) === null || _wager$joker === void 0 ? void 0 : _wager$joker.price),
      price: gameWager.calculateWagerPrice(wager),
      productItsId,
      uniqueId: "".concat(productItsId, "_").concat(index)
    });
  });
}
function gamesSortOrder(_ref3) {
  let games = _ref3.games,
    draws = _ref3.draws;
  const sortOrder = games.map(w => ({
    productItsId: w.productItsId,
    uniqueId: w.uniqueId
  }));
  const findDrawIndex = productItsId => draws.findIndex(d => d.productItsId === productItsId);
  sortOrder.sort((a, b) => findDrawIndex(a.productItsId) - findDrawIndex(b.productItsId));
  return sortOrder;
}
function getPackageDraws() {
  const drawsOptions = svs.gamePackage.data.packageConfig.drawsOptions;
  return drawsApi.findDraw(drawsOptions);
}
function getJackpots(_ref4) {
  let games = _ref4.games;
  const jackpotsList = games.map(game => {
    let kenoBoards;
    if (productMapping.isKeno(game.productItsId)) {
      kenoBoards = game.boards.map(board => ({
        kenoLevel: board.level,
        hasKungKeno: board.hasKungKeno,
        rowPrice: board.rowPrice * board.rowPriceMulti
      }));
    }
    const _jackpotApi$jackpot = jackpotApi.jackpot({
        product: game.productItsId,
        kenoBoards
      }),
      jackpotAmount = _jackpotApi$jackpot.jackpotAmount,
      description = _jackpotApi$jackpot.description,
      tagShort = _jackpotApi$jackpot.tagShort,
      jackpotAmountStringShort = _jackpotApi$jackpot.jackpotAmountStringShort;
    const jackpotDescription = tagShort ? "".concat(description, " ").concat(tagShort) : description;
    return {
      productItsId: game.productItsId,
      jackpotAmount,
      jackpotText: "".concat(jackpotDescription, " ").concat(jackpotAmountStringShort, " kr")
    };
  });
  games.map(game => {
    if (!game.hasJoker) {
      return null;
    }
    const _svs$numbergames$jack = svs.numbergames.jackpot.getJackpot({
        product: productMapping.getJokerProductId(game.productItsId),
        jokerPrice: game.joker.price
      }),
      jackpotAmount = _svs$numbergames$jack.jackpotAmount;
    return jackpotsList.push({
      productItsId: productMapping.getJokerProductId(game.productItsId),
      jackpotAmount
    });
  });
  return jackpotsList;
}
function calculatePackagePriceFromConfig(_ref5) {
  let games = _ref5.games,
    _ref5$tickets = _ref5.tickets,
    tickets = _ref5$tickets === void 0 ? [] : _ref5$tickets;
  const ticketsPrice = tickets.reduce((totalPrice, _ref6) => {
    let price = _ref6.price;
    return totalPrice + price;
  }, 0);
  const gamesPrice = games.reduce((totalPrice, _ref7) => {
    var _boardOptions$boards, _jokerOptions$price;
    let product = _ref7.product,
      hasLotto2 = _ref7.hasLotto2,
      boardOptions = _ref7.boardOptions,
      jokerOptions = _ref7.jokerOptions;
    const boards = (_boardOptions$boards = boardOptions.boards) !== null && _boardOptions$boards !== void 0 ? _boardOptions$boards : [boardOptions];
    const price = rules.getRules(product).rowPrice * boards.reduce((total, board) => total + board.count * (Boolean(board.hasKungKeno) + 1), 0) * (Boolean(hasLotto2) + 1) + ((_jokerOptions$price = jokerOptions === null || jokerOptions === void 0 ? void 0 : jokerOptions.price) !== null && _jokerOptions$price !== void 0 ? _jokerOptions$price : 0);
    return totalPrice + price;
  }, 0);
  return gamesPrice + ticketsPrice;
}
svs.gamePackage.mappers = {
  generateGames,
  gamesSortOrder,
  getPackageDraws,
  getJackpots,
  calculatePackagePriceFromConfig
};

 })(window);